module.exports = __webpack_public_path__ + "static/media/lucas_goncalves_nadalete.ffd1e2a7.jpg";